<template>
  <BaseCard class="ltablet:col-span-8 col-span-12 px-8 py-10 lg:col-span-8">
    <slot />
  </BaseCard>
</template>
